var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6316 19C16.9407 19 18.8948 17.02 18.8948 14.4737C18.8948 11.9273 16.9407 9.94735 14.6316 9.94735H4.50002C3.94774 9.94735 3.50002 9.49964 3.50002 8.94735C3.50002 8.39507 3.94774 7.94735 4.50002 7.94735H14.6316C18.1361 7.94735 20.8948 10.9158 20.8948 14.4737C20.8948 18.0315 18.1361 21 14.6316 21H9.36844C8.81616 21 8.36844 20.5523 8.36844 20C8.36844 19.4477 8.81616 19 9.36844 19L14.6316 19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 14.4737C9.10948 14.8642 8.47631 14.8642 8.08579 14.4737L3.39818 9.65446C3.21064 9.46692 3.10529 9.21257 3.10529 8.94735C3.10529 8.68214 3.21064 8.42778 3.39818 8.24025L8.08579 3.49998C8.47631 3.10946 9.10948 3.10946 9.5 3.49998C9.89052 3.89051 9.89052 4.52367 9.5 4.9142L5.5195 8.94735L9.5 13.0595C9.89052 13.45 9.89052 14.0831 9.5 14.4737Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIcon);
export default __webpack_public_path__ + "static/media/go-back-icon.f43a946266f7dd00b832f39f4ce5c43a.svg";
export { ForwardRef as ReactComponent };